module.exports = __webpack_public_path__ + "static/media/m8.a5139787.png";